// extracted by mini-css-extract-plugin
export var container = "P_c";
export var content = "P_cp";
export var sideSpace = "P_cl";
export var sidebar = "P_cm";
export var sidebarContent = "P_cn";